enum PortfolioAddDialogFields {
	MODE = "mode",
	FOLDERNAME = 'foldername',
	FILES = 'files',
	INITIAL_FILE = 'initial_file'
}

export default PortfolioAddDialogFields;